// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c37ecdce","879":"acf505d3"}[chunkId] + ".chunk.js";
};